/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

// YOU CAN USE THIS IF YOU WANT TO MOUNT THE React COMPONENT

import "./bootstrap";

import $ from "jquery";
window.$ = $;
window.jQuery = $;

// DataTables will be initialized by individual pages as needed
// This prevents the window property error

// Place any global JS needed for all pages below

// Import unified SweetAlert2 service
import swalService from "./utils/swalService";

/**
 * Alert and Notification System
 * Provides consistent alert handling across the admin interface
 * Now uses the unified swalService internally for consistent styling
 */
window.AlertManager = {
  // Show success alert
  showSuccess: function (message, title = "Success") {
    return swalService.success(message, title);
  },

  // Show error alert
  showError: function (message, title = "Error") {
    return swalService.error(message, title);
  },

  // Show warning alert
  showWarning: function (message, title = "Warning") {
    return swalService.warning(message, title);
  },

  // Show info alert
  showInfo: function (message, title = "Information") {
    return swalService.info(message, title);
  },

  // Show confirmation dialog
  showConfirm: function (
    message,
    title = "Confirm",
    confirmText = "Yes",
    cancelText = "No"
  ) {
    return swalService.confirm(message, title, confirmText, cancelText);
  },

  // Show delete confirmation
  showDeleteConfirm: function (itemName = "this item") {
    return swalService.deleteConfirm(itemName);
  },

  // Show toast notification
  showToast: function (message, type = "success", position = "top-end") {
    return swalService.toast(message, type, position);
  },
};
